const BaseUrl = 'https://site-gateway-dev.17mine.cn:9801'   //接口

export { BaseUrl }
